import { HtmlHTMLAttributes, useState } from 'react';

import {
  SelectComponent,
  SelectOptions,
  Option,
  SelectFakeDropShadow,
  OptionsContainer,
} from './_selectBox';

export interface OptionValues {
  label: string;
  value: string;
}

interface Props extends HtmlHTMLAttributes<HTMLDivElement> {
  placeholder: string;
  setSelectedItem: Function;
  selectedItem: OptionValues;
  options: Array<OptionValues>;
  borderRadius?: string;
}

export const SelectBox: React.FC<Props> = ({
  placeholder,
  setSelectedItem,
  selectedItem,
  options,
  borderRadius = undefined,
  ...rest
}) => {
  const [nowSelecting, setNowSelecting] = useState<boolean>(false);

  const renderOptions = () => {
    return (
      <>
        {options.map(({ label, value }) => {
          return (
            <Option
              onClick={() =>
                setSelectedItem({ ...{ label: label, value: value } })
              }
              key={value}
            >
              {label}
            </Option>
          );
        })}
      </>
    );
  };

  return (
    <>
      <SelectComponent
        className="select"
        nowSelecting={nowSelecting}
        borderRadius={borderRadius}
        onClick={() => setNowSelecting(!nowSelecting)}
        {...rest}
      >
        {selectedItem.label ? selectedItem.label : placeholder}
        <SelectOptions className="select__options" nowSelecting={nowSelecting}>
          <OptionsContainer className="select__options-container">
            {renderOptions()}
          </OptionsContainer>
        </SelectOptions>
      </SelectComponent>
      <SelectFakeDropShadow
        className="select__fake-dropshadow"
        nowSelecting={nowSelecting}
        onClick={() => setNowSelecting(!nowSelecting)}
      />
    </>
  );
};

export const SelectOption = Option;
